import { cn } from "@/lib/utils";

interface TankIconProps {
  type: "heated" | "general";
  size?: "sm" | "md" | "lg";
  className?: string;
}

const TankIcon = ({ type, size = "md", className }: TankIconProps) => {
  const isHeated = type === "heated";
  const dotColor = isHeated ? "bg-wle-red" : "bg-wle-blue";
  
  const sizes = {
    sm: "w-6 h-6",
    md: "w-8 h-8", 
    lg: "w-12 h-12"
  };
  
  const dotSizes = {
    sm: "w-2 h-2",
    md: "w-3 h-3",
    lg: "w-4 h-4"
  };

  return (
    <div className={cn("relative inline-flex items-center justify-center", sizes[size], className)}>
      {/* Tank outline */}
      <div className="w-full h-full border-2 border-muted-foreground rounded-lg bg-card relative">
        {/* Tank top */}
        <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-1/2 h-1 bg-muted-foreground rounded-t"></div>
        {/* Type indicator dot */}
        <div className={cn("absolute top-1 right-1 rounded-full", dotColor, dotSizes[size])}></div>
        {/* Tank legs */}
        <div className="absolute -bottom-1 left-2 w-0.5 h-1 bg-muted-foreground"></div>
        <div className="absolute -bottom-1 right-2 w-0.5 h-1 bg-muted-foreground"></div>
        
        {/* Heating coils for heated tanks */}
        {isHeated && (
          <div className="absolute inset-1 flex items-center justify-center">
            <div className="w-full h-0.5 bg-wle-red/30 rounded"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TankIcon;